import Reflux from 'reflux';
import storeUtils from '../../utils/store';

export default class DeliveryFeesStore extends Reflux.Store {
  static id = 'deliveryfees';

  constructor () {
    super();

    this.state = {
      fees: storeUtils.get('event_delivery_fees'),
      unoc: storeUtils.get('unoc')
    };
  }
};



// WEBPACK FOOTER //
// ./frontend/react/stores/deliveryfees/index.js